






















import Vue from 'vue'
import AllMetricsLivePatientStatus from '@/components/all-metrics-live/AllMetricsLivePatientStatus.vue'
import { LIVE_DASHBOARD_TYPES } from '@/constants/live-dashboard'
import { getPatientName } from '@/utils/patients'

export default Vue.extend({
  components: {
    AllMetricsLivePatientStatus,
  },
  props: {
    patientWithLiveDataLatest: {
      type: Object,
      required: true,
    },
    hasConcerningVitalSigns: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMultiple: true,
      displayTypes: [
        LIVE_DASHBOARD_TYPES.OxygenSaturations,
        LIVE_DASHBOARD_TYPES.PulseRates,
        LIVE_DASHBOARD_TYPES.BodyTemperatures,
        LIVE_DASHBOARD_TYPES.BodyWeights,
        LIVE_DASHBOARD_TYPES.BloodPressureSystolic,
        LIVE_DASHBOARD_TYPES.BloodPressureDiastolic,
      ],
    }
  },
  computed: {
    patientName() {
      return getPatientName({
        firstName: this.patientWithLiveDataLatest.firstName,
        lastName: this.patientWithLiveDataLatest.lastName,
        id: this.patientWithLiveDataLatest.id,
      })
    },
  },
})
